<div id="createHeroTile" class="preview_control">
  <ul class="nav nav-tabs" id="newHTATab" role="tablist">
    <li class="nav-item">
      <a class="nav-link active gtmAssetLibraryCreateHeroTileTitle" data-toggle="tab"  href="#alAddHeroTile" role="tab">
        <span>{{editCheck ? selectedHeroTileContent.publishedName: createHeroTileButton}}</span>
      </a>
    </li>
    <li class="nav-item exit_preview">
      <a class="nav-link gtmAssetLibraryCreateHeroTileCancel" (click)="cancel()">
        <img class="exit_changes" alt="exit without changes" />
      </a>
    </li>
  </ul>
  <div class="tab-content pages-tabs" id="newHTATab-content">
    <div class="tab-pane fade show active" id="alAddHeroTile"  role="tabpanel">
      <div id="heroTileFormTab" class="pages_default_tab">
        <form class="new_hta_content" [formGroup]="heroTileForm">
          <div id="heroTileFormContent">
            <div id="heroTileFormGroup" class="form-group">
              <label for=""><span i18n="@@global.tab-text.published-name">Published Name</span><span class="text-danger">*</span></label>
              <input type="text" class="form-control" placeholder={{publishNamePlaceholder}} id="publishedName" formControlName="publishedName" name="publishedName" maxlength="50"  required/>
              <div id="heroTilePublished" *ngIf="isPublished" class="formfield_err_msg"><span i18n="@@create-hero-tile.tab-pane.req-field">This is a required field.</span></div>
              <div id="heroTileSubmitted" *ngIf="isSubmitted && heroTileForm?.controls?.publishedName?.errors?.maxlength"
                class="formfield_err_msg"><span i18n="@@create-hero-tile.tab-pane.50-characters-long">Published name may be up to 50 characters long.</span></div>
              </div>
            <div id="internalNameFormGrp" class="form-group">
              <label for=""><span i18n="@@global.tab-text.internal-name">Internal Name</span></label>
              <input type="text" class="form-control"  id="internalName" placeholder={{internalNamePlaceholder}} formControlName="internalName" name="internalName" maxlength="50"/>
              <em class="err_icon"></em>
              <span id="emailErrMsg" class="formfield_err_msg"></span>
            </div>
            <div id="heroTileCardDesc" class="mt-3 card-desc">
              <div id="heroTileCardText" class="mb-2">
                <span i18n="@@create-hero-tile.retailer-hq">Retail HQ</span><span class="text-danger">*</span>
              </div>
              <div id="heroTileCardDropDown"class="card-desc selection-dropdown">
                <ng-select placement="top"
                  [items]="listOfRetailerHq" 
                  [placeholder]="retailSearch" bindLabel="name"
                  bindValue="id" name="retail-drop" [clearable]="true" 
                  [selectOnTab]="true"
                  [notFoundText]='globConst.NO_DATA_FOUND' 
                  (change)='getSelectedRetailer($event)'
                  [(ngModel)]="selectedRetailerId"
                  [ngModelOptions]="{standalone: true}"
                  >
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div>{{item.id}}</div>
                    {{item.name}}
                  </ng-template>
                </ng-select>
                <div id="retailerSearchIcon" *ngIf='!selectedRetailer' class="search-icon"></div>
              </div>
            </div>
          </div>
          <div id="seperator" class="inline_seperator"></div>
          <div id="mainTileSection">
            <div id="mainTileFormGroup" class="form-group">
              <label for="uploadedHeroTileImage">
                <span i18n="@@create-hero-tile.main-tile-image">Main Tile Image</span><span class="text-danger">*</span>
                <img class="info_icon" alt="hover for help" placement="top" [ngbPopover]="popContent"
                triggers="mouseenter:mouseleave" />
              </label>
              <ng-template #popContent>
                <div id="popOverContent" class="popover-upload-req maintileimage_tooltip">
                  <div id="popOverContentSection" class="d-flex align-items-center">
                    <img src="assets/images/image-icon.png" alt="image"/>
                    <ul>
                      <li><span i18n="@@create-hero-tile.image-format-popover">Images must be in <strong>JPG, PNG, JPEG, JFIF</strong> or <strong>GIF</strong> format.</span></li>
                      <li><span i18n="@@global.tooltip.image-max-size-error">Allowed maximum size is <strong>5 MB</strong></span></li>
                      <li class="herotileaspectratio"><span i18n="@@create-hero-tile.image-lg-aspect-ratio">Recommended Aspect ratio <strong>18:5</strong></span></li>
                    </ul>
                  </div>
                </div>
                </ng-template>
                <ng-template #popContentBanner>
                  <div id="popContentBanner"class="popover-upload-req">
                    <div id="popContentBannerSection" class="d-flex align-items-center">
                      <img src="assets/images/image-icon.png" alt="image"/>
                      <ul>
                        <li><span i18n="@@create-hero-tile.image-format-popover">Images must be in <strong>JPG, PNG, JPEG, JFIF</strong> or <strong>GIF</strong> format.</span></li>
                        <li><span i18n="@@global.tooltip.image-max-size-error">Allowed maximum size is <strong>5 MB</strong></span></li>
                        <li class="herotileaspectratio"><span i18n="@@create-hero-tile.image-sm-aspect-ratio">Recommended Aspect ratio <strong>9:5</strong></span></li>  
                      </ul>
                    </div>
                  </div>
                  </ng-template>
              
              <div id="uploadButton">
                <div id="uploadHeroTileSection1" class="d-flex">
                <label class="uploadHeroTileLabel">
                  <input #imageHeroTileInput id="uploadHeroTile" type="file"
                accept="image/jpg,image/jfif,image/x-png,image/jpeg,image/gif" (change)="uploadHeroTileImage($event)" hidden>
              <span class="btn btn-primary btn-sm left_icon_btn">
                <img class="upload_image" alt="upload image" /><span i18n="@@create-hero-tile.upload-image">Upload Image</span>
              </span>
                </label>
                <div id="uploadHeroTileSizeText" class="uploadHeroTileSizeText"><span i18n="@@create-hero-tile.upload-lg-aspect-ratio">Recommended Aspect ratio 18:5</span></div>
              </div>
                <div id="heroTileFileName" class="file-name-container" *ngIf="heroTileAvailable && heroTileFormat">{{heroTileFileName}}</div>
                <div id="heroTileTypeError" *ngIf="heroTileTypeError" class="uploadfile_err_msg"><span i18n="@@create-hero-tile.image-format-error">Image must be in <strong>JPG, GIF, or PNG</strong> format.</span></div>
                <div id="heroTileSizeError" *ngIf="heroTileSizeError && heroTileFormat" class="uploadfile_err_msg"><span i18n="@@global.content-grp.image-max-size-error">File exceeds maximum size <strong>(5 MB)</strong>.</span></div>
              </div>
            </div>
            <!-- IIT2-15095 -->
            <div id="hColor" class="form-group color-container BGColumn mt-3">
              <label for="" i18n="@@page.content.bg-color">Background color</label>
              <input readonly [(colorPicker)]="bgColor" [cpPosition]="'right'" [style.background]="bgColor" class="color_picker_button" (colorPickerChange)="emitPageDataToPreview()" role="button">
            </div>
            <div id="uploadGamingBannerFormGrp" class="form-group">
              <label for="uploadGamingBanner">
                <span i18n="@@create-hero-tile.gaming-tile-image">Gaming IPOS Banner</span><span class="text-danger">*</span>  
                <img class="info_icon" alt="hover for help" placement="right" [ngbPopover]="popContentBanner"
                triggers="mouseenter:mouseleave" />             
              </label>              
              <div id="uploadButton">
                <div class="d-flex" id="uploadHeroTileSection2">
                <label class="uploadHeroTileLabel">
                  <input #imageInput id="uploadLogo" type="file"
                accept="image/jpg,image/jfif,image/x-png,image/jpeg,image/gif" (change)="uploadGamingBanner($event)" hidden>
              <span class="btn btn-primary btn-sm left_icon_btn">
                <img class="upload_image" alt="upload image" /><span i18n="@@create-hero-tile.upload-image">Upload Image</span>
              </span>
                </label>
                <div id="uploadHeroTileSizeText2" class="uploadHeroTileSizeText"><span i18n="@@create-hero-tile.upload-sm-aspect-ratio">Recommended Aspect ratio 9:5</span></div>
              </div>
                <div id="gamingBannerFileName" class="file-name-container" *ngIf="gamingBannerAvailable && gamingBannerFormat">{{gamingBannerFileName}}</div>
                <div id="gamingBannerTypeError" *ngIf="gamingBannerTypeError" class="uploadfile_err_msg"><span i18n="@@create-hero-tile.image-format-error">Image must be in <strong>JPG, GIF, or PNG</strong> format.</span></div>
                <div id="gamingBannerSizeError" *ngIf="gamingBannerSizeError && gamingBannerFormat" class="uploadfile_err_msg"><span i18n="@@global.content-grp.image-max-size-error">File exceeds maximum size <strong>(5 MB)</strong>.</span></div>
              </div>
            </div>
            <!-- IIT2-15095 -->
            <div id="hColor" class="form-group color-container BGColumn mt-3">
              <label for="" i18n="@@page.content.bg-color">Background color</label>
              <input readonly [(colorPicker)]="gamingBgColor" [cpPosition]="'right'" [style.background]="gamingBgColor" class="color_picker_button" (colorPickerChange)="emitPageGamingDataToPreview()" role="button">
            </div>
            <div id="callToActionFormGrp" class="form-group">
              <label for=""><span i18n="@@create-hero-tile.call-to-action">Call-to-Action</span><span class="text-danger">*</span></label>
              <input  type="text" class="form-control" placeholder={{callToActionPlaceholder}} (input)="sendCTAText($event.target.value)" formControlName='callToAction' name="ctatext"  maxlength="50" required />
              <em class="err_icon"></em>
              <span id="emailErrMsg" class="formfield_err_msg"></span>
            </div>
          </div>
          <div id="inlineSeperator" class="inline_seperator"></div>
          <div id="strUrl">
            <div id="strUrlFormGrp" class="form-group">
              <label for="">{{srtUrlText}}<span class="text-danger">*</span></label>
              <input type="url" class="form-control" placeholder={{srtUrlPlaceholder}} formControlName="srtUrl" (keyup)="validateUrl($event)" required/>                
                <div id="patterMatchErr" *ngIf="!this.patterMatch" class="formfield_err_msg" [innerHTML]='emailValidationMsg'>
                </div>
            </div>
            <div id="fallbackZipFormGrp" class="form-group">
              <label for=""><span i18n="@@create-hero-tile.fallback-zip-file-label">Fallback Zip File</span><span class="text-danger">*</span>
              </label>
              <ng-template #popExeContent><div class="popup-content"><span i18n="@@create-hero-tile.fallback-zip-file-condition">The Fallback zip will run in the event that your device is <strong>offline.</strong> This zip <strong>only runs on Windows* devices.</strong></span></div></ng-template>
              <img class="info_icon" alt="hover for help" placement="bottom-right" [ngbPopover]="popExeContent"
              triggers="mouseenter:mouseleave" />
              <div id="uploadButton">
                <label>
                  <input #exeFileInput id="uploadLogo" type="file"
                  accept=".zip,.rar,.7zip" (change)="uploadFallbackExe($event)" hidden>
              <span class="btn btn-primary btn-sm left_icon_btn">
                <img class="upload_exe" alt="upload image" /><span i18n="@@create-hero-tile.upload-zip-file-btn">Upload Zip File</span></span>
                </label>
                <div id="fileName" class="file-name-container" *ngIf="isFileAvailable && isFileFormat">{{fileName}}</div>
                <div id="fileTypeError" *ngIf="fileTypeError" class="uploadfile_err_msg"><span i18n="@@create-hero-tile.fallback-zip-file-error">Incorrect file type received. File must be in <strong>ZIP format</strong>.</span></div>
                <div id="fileSizeError" *ngIf="fileSizeError && isFileFormat" class="uploadfile_err_msg"><strong><span i18n="@@create-hero-tile.fallback-zip-file-size-error">File exceeds maximum size <strong>(3 MB)</strong>.</span></strong></div>
              </div>
            </div>
          </div>
        </form>
        <div id="btnWrapper" class="button-wrapper justify-content-end">
          <button type="button" class="btn btn-outline-primary gtmAssetLibraryCreateHeroTileCancel" (click)="cancel()">
            <span i18n="@@create-hero-tile.cancel">Cancel</span>
          </button>
          <button type="button" class="btn btn-primary gtmAssetLibraryCreateHeroTileSaveAndProceeed" (click)="onAdd()"
          [disabled]="!heroTileForm.controls.publishedName.value || !heroTileForm.controls.srtUrl.value || !heroTileForm.controls.callToAction.value  || isSubmitted || !isRetailerAvailable ||!gamingBannerAvailable || !heroTileAvailable || !heroTileFormat || !gamingBannerFormat || !isFileAvailable || !isFileFormat">
            <span class="gtmAssetLibraryCreateHeroTileSaveAndProceeed" i18n="@@create-hero-tile.save-and-proceed">Save and Proceed</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
